<div class="position-relative">
    <overlay-spinner *ngIf="loading"></overlay-spinner>
    <div class="patient-content">
        <h3>Adherence Trends</h3>
        <div class="row">
            <div class="col-md-6">
                <h5>Chapter Adherence</h5>
                <apx-chart
                    [series]="disabled? [] : chapterSeries"
                    [chart]="chartOptions.chart"
                    [xaxis]="chartOptions.xaxis"
                    [yaxis]="chartOptions.yaxis"
                    [stroke]="chapterStroke"
                    [fill]="chapterFill"
                    [tooltip]="chartOptions.tooltip"
                    [legend]="chartOptions.legend"
                >
                </apx-chart>
            </div>
            <div class="col-md-6">
                <h5>Check-in Adherence</h5>
                <apx-chart
                    [series]="disabled? [] : checkinSeries"
                    [chart]="chartOptions.chart"
                    [xaxis]="chartOptions.xaxis"
                    [yaxis]="chartOptions.yaxis"
                    [stroke]="checkinStroke"
                    [fill]="checkinFill"
                    [tooltip]="chartOptions.tooltip"
                    [legend]="chartOptions.legend"
                >
                </apx-chart>
            </div>
        </div>
    </div>
</div>

